module.exports = __webpack_public_path__ + "static/img/login-illu.8a8e248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-illu.png
// module id = OfEy
// module chunks = 0